export type AwsCloudFormationQuickCreateOptions = {
  region: string;
  templateUrl: string;
  stackName?: string;
  parameters?: Record<string, string | number | boolean | null | undefined>;
};

const normalizeParameterValue = (key: string, rawValue: string | number | boolean): string => {
  const value = typeof rawValue === 'boolean' ? String(rawValue) : String(rawValue).trim();
  if (key === 'TelemetryHealthCheckPort' && (!value || value === '22')) {
    return '601';
  }
  return value;
};

export function buildCloudFormationQuickCreateUrl({
  region,
  templateUrl,
  stackName,
  parameters = {}
}: AwsCloudFormationQuickCreateOptions): string {
  const normalizedRegion = region.trim();
  const normalizedTemplateUrl = templateUrl.trim();

  if (!normalizedRegion) {
    throw new Error('AWS region is required.');
  }
  if (!normalizedTemplateUrl) {
    throw new Error('CloudFormation template URL is required.');
  }

  const base = new URL(`https://${normalizedRegion}.console.aws.amazon.com/cloudformation/home`);
  base.searchParams.set('region', normalizedRegion);

  const reviewParams = new URLSearchParams();
  reviewParams.set('templateURL', normalizedTemplateUrl);

  const normalizedStackName = stackName?.trim();
  if (normalizedStackName) {
    reviewParams.set('stackName', normalizedStackName);
  }

  for (const [key, rawValue] of Object.entries(parameters)) {
    if (rawValue == null) {
      continue;
    }
    const value = normalizeParameterValue(key, rawValue);
    if (!value) {
      continue;
    }
    reviewParams.set(`param_${key}`, value);
  }

  base.hash = `/stacks/create/review?${reviewParams.toString()}`;
  return base.toString();
}
